import { useUploadTaskCompletionRefetch } from "../queries/query-upload-task";

export function FetchThings() {
  useUploadTaskCompletionRefetch();

  return null;
}
